import React from 'react'
import { FeatureTab } from './FeatureTabs';
import Link from 'next/link';
import Image from 'next/image';
import { Button } from '@/components/ui/button';

export default function FeaturePanelContent({
    feature,
    t,
}: {
    feature: FeatureTab
    t: (key: string) => string
}) {
    return (
        <div className="grid grid-cols-1 items-center gap-6 md:grid-cols-[1.05fr_1fr] md:gap-10">
            <div>
                <h3 className="mb-3 font-[Poppins,sans-serif] text-[20px] font-semibold leading-[1.25] text-[#2E2E38] sm:text-[24px] md:mb-4 md:text-[28px]">
                    {t(feature.titleKey) || feature.titleFallback}
                </h3>

                <p className="mb-4 text-[14px] leading-[1.65] text-[#6B6B76] sm:text-[15px] md:mb-5 md:text-[15.5px]">
                    {t(feature.descKey) || feature.descFallback}
                    {feature.descBoldKey && (
                        <strong className="font-semibold text-[#2E2E38]">
                            {t(feature.descBoldKey) || feature.descBoldFallback}
                        </strong>
                    )}
                </p>

                {feature.desc2Key && (
                    <p className="mb-4 text-[14px] leading-[1.65] text-[#6B6B76] sm:text-[15px] md:mb-5 md:text-[15.5px]">
                        {t(feature.desc2Key) || feature.desc2Fallback}
                    </p>
                )}

                {feature.listGroups.map((group) => (
                    <div key={group.titleKey} className="mb-4 last:mb-0 md:mb-5">
                        <p className="mb-2 font-[Poppins,sans-serif] text-[14px] font-semibold text-[#2E2E38] md:mb-2.5 md:text-[15px]">
                            {t(group.titleKey) || group.titleFallback}
                        </p>
                        <ul className="m-0 list-disc pl-5 text-[14px] leading-[1.85] text-[#4A4A55] sm:text-[15px] md:text-[15.5px] md:leading-[1.95]">
                            {group.items.map((item) => (
                                <li key={item.key}>{t(item.key) || item.fallback}</li>
                            ))}
                        </ul>
                    </div>
                ))}

                <Button
                    asChild
                    className="mt-5 w-full rounded-xl bg-[#2E2E38] px-[26px] py-[13px] font-[Poppins,sans-serif] text-[14px] font-semibold text-white hover:bg-[#1c1c24] sm:w-auto sm:text-[15px] md:mt-6"
                >
                    <Link href={feature.href}>{t(feature.btnKey) || feature.btnFallback}</Link>
                </Button>
            </div>

            <div className="relative order-first h-[200px] w-full overflow-hidden rounded-[16px] sm:h-[240px] md:order-none md:h-full md:min-h-[320px] md:rounded-[18px]">
                <Image
                    src={feature.image}
                    alt={t(feature.altKey) || feature.altFallback}
                    fill
                    className="object-contain"
                    sizes="(max-width: 768px) 100vw, 40vw"
                />
            </div>
        </div>
    )
}